import React, { useState, useEffect } from 'react';
import './../../assets/scss/ScrollToTopButton.scss';

function ScrollToTopButton() {
    const [isVisible, setIsVisible] = useState(false);
    const [isUp, setIsUp] = useState(true); //state to track whether arrow is pointing up or down

    useEffect(() => {
        const toggleVisibility = () => {
            if (window.pageYOffset > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };
        window.addEventListener("scroll", toggleVisibility);
        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    const scrollToBottom = () => {
        window.scrollTo({
            top: document.body.scrollHeight,
            behavior: "smooth"
        });
    };

    const handleButtonClick = () => {
        if (isUp) {
            scrollToTop();
        } else {
            scrollToBottom();
        }
    };

    const handleScroll = () => {
        if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
            setIsUp(true);
        } else {
            setIsUp(false);
        }
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <div className="scroll-to-top-button">
            {isVisible &&
                <button onClick={handleButtonClick}>
                    {isUp ? <div className="arrow-icon arrow-up"></div> : <div className="arrow-icon arrow-down"></div>}
                </button>
            }
        </div>
    );
}

export default ScrollToTopButton;
